import Vue from "vue";
import Router from "vue-router";
import store from "./store/main.js";
import { LOCAL_STORAGE_SUPPLIER} from "./mixins/constants";
import { setItemStorage } from "@/plugins/utils"
import { NotificationProgrammatic as Notification } from 'buefy'
// import { DialogProgrammatic as Dialog } from 'buefy'
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      name: "signup",
      path: "/",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/sign-up/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 1 }
    },
    {
      name: "signin",
      path: "/sign-in",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/sign-in/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 1 }
    },
    {
      name: "activate",
      path: "/activate",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/sign-in/Activate.vue"
        ),
      meta: { layout: "onboarding", step_id: 1 },
      props: true
    },
    {
      name: "document",
      path: "/upload",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/attach-file/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 2 , requiresAuth: true }
    },
    {
      name: "profile",
      path: "/profile",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/profile/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 3 , requiresAuth: true }
    },
    {
      name: "training",
      path: "/training",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 4, requiresAuth: true, inAppBrowserSupport: true }
    },
    {
      name: "courses",
      path: "/courses-v1",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/Courses.vue"
        ),
      meta: { layout: "onboarding", step_id: 4, requiresAuth: true, inAppBrowserSupport: true }
    },
    {
      name: "course",
      path: "/course/:slug",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/Course.vue"
        ),
      meta: { layout: "online-training", requiresAuth: true, inAppBrowserSupport: true }
    },
    // TODO: support old link: online-training/
    {
      name: "course-v1",
      path: "/online-training-v1/course/:id",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/CourseV1.vue"
        ),
      meta: { layout: "default"}
    },

    {
      name: "result",
      path: "/course-v1/result",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/Result.vue"
        ),
      meta: { layout: "online-training", requiresAuth: true, inAppBrowserSupport: true }
    },
    {
      name: "result-v1",
      path: "/online-training-v1/result",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/training/ResultV1.vue"
        ),
      meta: { layout: "default"}
    },

    {
      name: "contract",
      path: "/contract",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/contract/Index.vue"
        ),
      meta: { layout: "onboarding", step_id: 5 , requiresAuth: true }
    },
    {
      name: "covid-test",
      path: "/covid-test",
      component: () =>
        import(
          /* webpackChunkName: "contract" */ "./modules/covid-test/index.vue"
        ),
      meta: { layout: "default", inAppBrowserSupport: true}
    },
    {
      name: "covid-test-form",
      path: "/covid-test/:id",
      component: () =>
        import(
          /* webpackChunkName: "contract" */ "./modules/covid-test/covid-infomation.vue"
        ),
      meta: { layout: "default", inAppBrowserSupport: true}
    },
    {
      name: "delete-account",
      path: "/help-center/delete-account",
      component: () =>
        import(
          /* webpackChunkName: "delete-account" */
          "./modules/delete-account/Index.vue"
        ),
      meta: {
        layout: "default",
        requiresAuth: true,
        inAppBrowserSupport: true,
      },
    },
    {
      name: "popup",
      path: "/popup",
      component: () =>
        import(
          /* webpackChunkName: "driver-onboarding" */ "./modules/Popup.vue"
        ),
      meta: { layout: "default"}
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

const getSupplierProfile = async (token) => {
  let result = null
  await store.dispatch("getProfile", token).then(response => {
    if(response && response.status === 200 && response.data && response.data.supplier){
      result = response.data.supplier
    }
 }).catch(error => {
    Vue.prototype.$deleteCookie('supplier_token')
    Vue.prototype.$deleteCookie('timer')
    store.state.active_step = 1
    Notification.open({
      message: `Lỗi ${error.status}: ${error.data.title}`,
      type: "is-danger",
      duration: 4000,
      position: "is-bottom"
    })
 })
  return result 
}

router.beforeEach(async (to, from, next) => {
  const fromLayout = from && from.meta && from.meta.layout;
  const toLayout = to.meta && to.meta.layout;
  if (toLayout && toLayout !== fromLayout) {
    store.commit("SET_LAYOUT", toLayout);
  }

  const toStepId = to.meta && to.meta.step_id;
  store.commit("SET_ACTIVE_STEP", toStepId);
  
  if(to.matched.some(e => e.meta.requiresAuth)) {
    const token = store.getters.supplierToken
    let supplierProfile = store.getters.supplierProfile

    if (!supplierProfile && token) {
      supplierProfile = await getSupplierProfile(token)
      
      if (supplierProfile) {
        store.dispatch('setSupplierProfile', supplierProfile)
        setItemStorage(LOCAL_STORAGE_SUPPLIER, JSON.stringify(supplierProfile))
      }
    }

    if (!supplierProfile) {
      to.path !== '/sign-in' && next({ path : '/sign-in' })
      return
    }
    
    if(supplierProfile && !supplierProfile.extra && to.name === 'training'){
      to.path !== '/profile' && next({ path : '/profile' })
    }

    const isVerified = supplierProfile.verified


    if (isVerified && to.name === 'training-v1') {
      next({
        path : '/courses-v1',
      })
    }

    

    if (isVerified && (to.name !== 'contract' && to.name !== 'delete-account') && screen.width > 1024) {
      next({
        path : '/contract',
      })
    }

    if(!isVerified && to.name === 'courses') {
      next({
        path : '/training-v1',
      })
    }

    // if(to.matched.some(e => !e.meta.inAppBrowserSupport) 
    //   && screen.width < 1024 
    //   && to.path !== '/training' 
    //   && supplierProfile.verified)
    //   {
    //     next({
    //       path : '/training'
    //     })
    //   }
  }

  if(screen.width < 1024 && to.path.indexOf('/pt') === 0) {
    next()
  }

  if(to.matched.some(e => !e.meta.inAppBrowserSupport) && screen.width < 1024 && to.path !== '/popup') {
    next({
      path : '/popup'
    })
  }

  next();
});

export default router;
